// extracted by mini-css-extract-plugin
export var baseButton = "_wf-0";
export var controlsArrowKeys = "_wf-1";
export var controlsResetButton = "_wf-2";
export var lightGameButton = "_wf-4 _wf-0";
export var playAgainButton = "_wf-5 _wf-0";
export var startGameButton = "_wf-3 _wf-0";